export default {
    bind(el, binding) {
        el.dataset.position = binding.value;
    }
};
